import { EventEmitter } from "fbemitter";
const emitter = new EventEmitter();
export default emitter;
export const CloseDrawer = () => emitter.emit("HIDE_DRAWER");
export const CloseAllDrawers = () => emitter.emit("HIDE_ALL_DRAWER");

export const queryFire = (query) =>
  emitter.emit("TRIGGER_QUERY", { query: query });
